import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getApi } from "@/api/api-configuration";

import { fetchAllPages } from "./helpers/fetch-all-pages";

const uploadApi = getApi();

// ─── LIST ─────────────────────────────────────────────────────────────────────

const getOrganisationsListAllPagesQuery = () => ({
  queryKey: ["organisations-list-all"],
  queryFn: () => fetchAllPages((pageOptions) => uploadApi.apiOrganisationsList({ ...pageOptions })),
});

export const useOrganisationsListAllPagesQuery = () => {
  return useQuery(getOrganisationsListAllPagesQuery());
};

// ─── INVALIDATION ─────────────────────────────────────────────────────────────

export const useInvalidateOrganisationsQueries = () => {
  const queryClient = useQueryClient();
  return async () => {
    await queryClient.invalidateQueries({
      queryKey: getOrganisationsListAllPagesQuery().queryKey,
      refetchType: "all",
    });
  };
};
